/**
 * MEDIA-VIEWER.JS
 */

import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-video.css';

export default function InitMediaViewer() {
	const lightGalleries = document.querySelectorAll('.media-viewer');
	if (lightGalleries.length === 0) return;

	const triggerElements = document.querySelectorAll('.lg-trigger');
	triggerElements.forEach((element) => {
		element.addEventListener('click', () => {
			let target = document.getElementById(element.getAttribute('data-trigger'));

			if(target) {
				var startGalleryEvent = new CustomEvent('click', {bubbles: true, cancelable: true});
				target.dispatchEvent(startGalleryEvent);
			}
		});
	});

	if(window.lgInstances && window.lgInstances.length > 0){
		window.lgInstances.forEach((gallery) => {
			gallery.destroy();
		});
	}

	setTimeout(function() {
		window.lgInstances = [];

		lightGalleries.forEach((gallery) => {
			var lg = lightGallery(gallery, {
				licenseKey: 'HJ7KN-STGR7-R8KGF-CU3W3',
				plugins: [lgVideo],
				selector: '.media-viewer-item',
				mobileSettings: {
					showCloseIcon: true
				}
			});
			window.lgInstances.push(lg);
		});
	}, 50);
}